import * as React from 'react';
import { clsx } from 'clsx';
import { UIText1 } from '../../../../typography';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SuggestionTitleItem = /*#__PURE__*/React.forwardRef((props, iconRef) => {
  return /*#__PURE__*/_jsxs("li", {
    className: clsx(styles['item'], styles[props.variant]),
    role: "option",
    tabIndex: -1,
    "data-testid": "suggesttion-title-item",
    children: [props.leftIcon && /*#__PURE__*/_jsx("div", {
      ref: iconRef,
      className: styles['left-icon'],
      children: props.leftIcon
    }), /*#__PURE__*/_jsx("div", {
      className: clsx(styles['name'], styles[props.variant]),
      children: /*#__PURE__*/_jsx(UIText1, {
        display: "inline",
        fontWeight: "700",
        children: props.title
      })
    })]
  });
});
SuggestionTitleItem.displayName = 'SuggestionItem';